import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

const toResourceSheetQueryParams = (data = {}) => {
  const params = new URLSearchParams();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === null || value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      if (!value.length) {
        return;
      }
      value.forEach((item) => {
        if (item !== null && item !== undefined && item !== "") {
          params.append(key, item);
        }
      });
      return;
    }
    params.append(key, value);
  });
  return params;
};

export default class ResourceSheetService extends BaseService {
  fetchResourceSheets = ({ page = 1, size = 10, ...data }) => {
    return this.axios.get(API_ENDPOINTS.LIST_RESOURCE_SHEET, {
      params: toResourceSheetQueryParams({ page, size, ...data }),
    });
  };

  saveResourceSheet = ({ entries, holds, tasks, teamDoId, teamCheckId }) => {
    return this.axios.post(API_ENDPOINTS.SAVE_RESOURCE_SHEET, {
      entries,
      holds,
      tasks,
      teamDoId,
      teamCheckId,
    });
  };

  fetchEditLogs = ({ side, teamId, page = 1, size }) => {
    return this.axios.get(API_ENDPOINTS.LIST_RESOURCE_SHEET_EDIT_LOG, {
      params: toResourceSheetQueryParams({ side, teamId, page, size }),
    });
  };

  fetchDeadlineIssues = (data = {}) => {
    return this.axios.get(`${API_ENDPOINTS.LIST_RESOURCE_SHEET}/deadline-issues`, {
      params: toResourceSheetQueryParams(data),
    });
  };
}
